module.exports = __webpack_public_path__ + "img/shili.56047086.png";